import { useRoutes } from 'react-router-dom';
import { useState, useEffect } from 'react';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import Cookies from 'js-cookie';
import CreatProfileRoutes from './CreatProfileRoutes';
import { checkForAuthorization } from 'utilities/index';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    const [isProfileComplete, setIsProfileComplete] = useState(
        (Cookies.get("is_profile_complete") != "" && Cookies.get("is_profile_complete") !== undefined) && Cookies.get("is_profile_complete") != "false"
    );
    const [isAuthorized, setIsAuthorized] = useState(checkForAuthorization() !== "" && checkForAuthorization() !== undefined);

    useEffect(() => {
        const checkCookieChanges = setInterval(() => {
            const isProfileCompleteValue = (Cookies.get("is_profile_complete") != "" && Cookies.get("is_profile_complete") !== undefined) && Cookies.get("is_profile_complete") != "false";
            const isAuthorizedValue = checkForAuthorization() !== "" && checkForAuthorization() !== undefined;

            setIsProfileComplete(isProfileCompleteValue);
            setIsAuthorized(isAuthorizedValue);
        }, 500);

        return () => clearInterval(checkCookieChanges);
    }, []);

    var routes = isAuthorized ? (isProfileComplete ? MainRoutes : CreatProfileRoutes) : AuthenticationRoutes;
    return useRoutes([routes])
}
